module.exports = "<variable-plans-page></variable-plans-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appPlans/variables.html
// module id = 2094
// module chunks = 0